import React, { Component } from 'react';

import axios from '../../axios';

class Test extends Component {
  state = {
  }
  componentDidMount() {
    axios.get('/api/store')
      .then(response => {
        console.log( response );
      })
      .catch(error => {
        console.log(error);
        //this.setState({ error: true });
      });
  }
  render() {
    return (
      <div>
        <h1>Test</h1>
      </div>
    )
  }
};


export default Test;


// WEBPACK FOOTER //
// ./src/containers/TestContainer/TestContainer.js